<p8-layout-settings-page>
  <mat-card>
    <mat-card-title>
        <p8-layout-settings-header [titlePath]="[getTitle()]"
                                 [iconRacine]="'inventory_2'"></p8-layout-settings-header>
    </mat-card-title>
    <mat-card-content>
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start"
                     [(selectedIndex)]="selectedTabIndex">
        <mat-tab label="Demande de Consultation">
          <form [formGroup]="consultationForm">
            <div fxLayoutAlign="end end">
              <span>Les champs ou parties marqués par un <strong class="mandatory-field">*</strong> sont obligatoires pour pouvoir envoyer votre demande de consultation</span>
            </div>
            <div fxLayout="column">
              <!-- Informations demandeur ou pour quelle personne -->
              <div>
                <mat-card class="mat-elevation-z3">
                  <mat-card-content fxLayout="column">
                    <p class="mat-h2">
                      <mat-icon style="padding-right: 10px;" color="primary"
                                matBadgePosition="after"
                                matBadge="1" matBadgeColor="warn">description</mat-icon>
                      Informations<span class="mandatory-field"> *</span></p>
                    <mat-card>
                      <mat-card-content>
                        <div fxLayoutGap="2px">
                                <mat-form-field appearance="outline" fxFlex="50">
                                  <mat-label data-cy="label-consult-edit-dir-cmp"><span class="mandatory-field">* </span><b>Direction ou Composante</b></mat-label>
                                  <mat-select formControlName="{{FIELD_DIR_CMP}}"
                                              (selectionChange)="onSelectDirCmp()">
                                    <mat-option *ngFor="let entite of dirCmpArchivage"
                                                [value]="entite?.id"
                                                [attr.data-cy]="'option-deposit-edit-dirCmp-' + entite?.id">
                                      {{ entite?.entite_archivage_obj?.entite_obj?.name }}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                                <mat-form-field appearance="outline" fxFlex="50">
                                  <input type="text"
                                         maxlength="{{formMaxLengthProperty(FIELD_SVC)}}"
                                         formControlName="{{FIELD_SVC}}"
                                         matInput
                                         [UpperCaseFirstLetter]="true"
                                         placeholder="saisir le service / pôle / département / labo / ...le cas échéant"
                                         matTooltip="saisir le service / pôle / département / labo / ...le cas échéant"
                                         data-cy="input-consult-edit-svc"/>
                                  <mat-hint align="end"><code>{{formControlProperty(FIELD_SVC).value?.length}}</code> / <code>{{formMaxLengthProperty(FIELD_SVC)}}</code></mat-hint>
                                </mat-form-field>
                        </div>
                        <!-- demandeur -->
                        <div fxLayoutGap="2px">
                          <mat-form-field appearance="outline" fxFlex="50">
                            <mat-label><span class="mandatory-field">* </span>Bureau</mat-label>
                            <input type="text"
                                   maxlength="{{formMaxLengthProperty(FIELD_OFFICE)}}"
                                   [UpperCaseFirstLetter]="true"
                                   formControlName="{{FIELD_OFFICE}}"
                                   matInput placeholder="G318" data-cy="input-consult-edit-office"/>
                            <mat-hint align="end"><code>{{formControlProperty(FIELD_OFFICE).value?.length}}</code> / <code>{{formMaxLengthProperty(FIELD_OFFICE)}}</code></mat-hint>
                          </mat-form-field>
                          <mat-form-field appearance="outline" fxFlex="50">
                            <mat-label><span class="mandatory-field">* </span>Numéro de téléphone</mat-label>
                            <input type="text"
                                   maxlength="{{formMaxLengthProperty(FIELD_PHONENUMBER)}}"
                                   formControlName="{{FIELD_PHONENUMBER}}"
                                   matInput placeholder="+33612345678" data-cy="input-consult-edit-phonenumber"/>
                            <mat-hint align="end"><code>{{formControlProperty(FIELD_PHONENUMBER).value?.length}}</code> / <code>{{formMaxLengthProperty(FIELD_PHONENUMBER)}}</code></mat-hint>
                          </mat-form-field>
                        </div>
                        <div fxLayout="row" fxLayoutGap="2px">
                          <mat-form-field appearance="outline" fxFlex="50">
                            <mat-label><span class="mandatory-field">* </span>Nom</mat-label>
                            <input type="text"
                                   [UpperCaseFirstLetter]="true"
                                   maxlength="{{formMaxLengthProperty(FIELD_LAST_NAME)}}"
                                   matTooltip="vous-même ou la personne ayant fait la demande à votre service"
                                   formControlName="{{FIELD_LAST_NAME}}"
                                   matInput placeholder="DO" data-cy="input-consult-edit-last_name"/>
                            <mat-hint align="end"><code>{{formControlProperty(FIELD_LAST_NAME).value?.length}}</code> / <code>{{formMaxLengthProperty(FIELD_LAST_NAME)}}</code></mat-hint>
                          </mat-form-field>
                          <mat-form-field appearance="outline" fxFlex="50">
                            <mat-label><span class="mandatory-field">* </span>Prénom</mat-label>
                            <input type="text"
                                   [UpperCaseFirstLetter]="true"
                                   maxlength="{{formMaxLengthProperty(FIELD_FIRST_NAME)}}"
                                   matTooltip="vous-même ou la personne ayant fait la demande à votre service"
                                   formControlName="{{FIELD_FIRST_NAME}}"
                                   matInput placeholder="John" data-cy="input-consult-edit-first_name"/>
                            <mat-hint align="end"><code>{{formControlProperty(FIELD_FIRST_NAME).value?.length}}</code> / <code>{{formMaxLengthProperty(FIELD_FIRST_NAME)}}</code></mat-hint>
                          </mat-form-field>
                        </div>
                      </mat-card-content>
                    </mat-card>
                  </mat-card-content>
                </mat-card>
              </div>
              <!-- les critères de la demande -->
              <div>
                <mat-card class="mat-elevation-z3">
                  <mat-card-content>
                    <div fxLayout="row">
                      <div fxLayoutAlign="start" fxFlex>
                        <span class="mat-h2"><mat-icon style="padding-right: 10px;" color="primary"
                                                       matBadgePosition="after"
                                                       matBadge="2" matBadgeColor="warn">inventory</mat-icon>Ma demande<span
                          class="mandatory-field"> *</span></span>
                      </div>
                    </div>
                    <mat-card>
                      <mat-card-content>
                        <div>
                          <mat-label><strong>Années</strong> du document - dates extrêmes : de l'année N (min) à l'année M (max)</mat-label>
                        </div>
                        <div fxLayout="row" fxLayoutGap="2px">
                          <mat-form-field appearance="outline" fxFlex="50">
                            <mat-label><span class="mandatory-field">* </span>de l'année</mat-label>
                            <input type="number"
                                   pattern="\d*"
                                   formControlName="{{FIELD_YEAR_MIN}}"
                                   matInput placeholder="2015" data-cy="input-consult-edit-year_min"/>
                            <mat-error *ngIf="formControlProperty(FIELD_YEAR_MIN)?.hasError('invalidYear')">
                              L'année n'est pas valide, elle doit être au format AAAA et être supérieure à 1964 et maximum sur l'année en cours
                            </mat-error>
                          </mat-form-field>

                          <mat-form-field appearance="outline" fxFlex="50">
                            <mat-label>à l'année</mat-label>
                            <input type="number"
                                   pattern="\d*"
                                   formControlName="{{FIELD_YEAR_MAX}}"
                                   matInput placeholder="2020" data-cy="input-consult-edit-year_max"/>
                            <mat-error *ngIf="formControlProperty(FIELD_YEAR_MAX)?.hasError('invalidYear')">
                              L'année n'est pas valide, elle doit être au format AAAA et être supérieure à 1964 et maximum sur l'année en cours
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div fxLayout="row" fxLayoutGap="2px" *ngIf="consultationForm?.hasError('yearRangeInvalid')">
                          <div fxFlex="50"></div>
                          <div fxFlex="50" style="padding-bottom: 5px;">
                            <mat-error>
                              <strong>La 1ère année (de l'année) doit être inférieure à la 2ème année (à l'année)</strong>
                            </mat-error>
                          </div>
                        </div>
                        <div>
                          <mat-form-field appearance="outline" fxFlex="50">
                            <mat-label><span class="mandatory-field">* </span>Typologie du document (PV de rsultats, diplômes, factures, ...)</mat-label>
                            <input type="text"
                                   formControlName="{{FIELD_TYPOLOGIE}}"
                                   maxlength="{{formMaxLengthProperty(FIELD_TYPOLOGIE)}}"
                                   matInput placeholder="PV de classement, diplôme, ..." data-cy="input-consult-edit-typologie"/>
                            <mat-hint align="end"><code>{{formControlProperty(FIELD_TYPOLOGIE).value?.length}}</code> / <code>{{formMaxLengthProperty(FIELD_TYPOLOGIE)}}</code></mat-hint>
                          </mat-form-field>
                        </div>
                        <div>
                          <mat-form-field appearance="outline" fxFlex="50">
                            <mat-label><span class="mandatory-field">* </span>Description détaillée pour la recherche dans les magasins d'archives</mat-label>
                            <textarea matInput
                                      placeholder="détail de l'étudiant, code étudiant, agent, ..."
                                      formControlName="{{FIELD_DETAILS}}"
                                      data-cy="input-consult-edit-details">
                            </textarea>
                          </mat-form-field>
                        </div>
                      </mat-card-content>
                    </mat-card>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </form>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
  <p8-layout-settings-footer [flexLayoutAlign]="'end'">
    <button mat-raised-button type="button" (click)="backToPreviousUrl()" matTooltip="Retour" data-cy="btn-consult-edit-back">
      Retour à votre liste
    </button>
    <span style="border-left: 1px solid #9a9a9a; height: 36px; margin-right: 24px;"></span>
    <span>
      <button mat-raised-button type="button" (click)="saveConsultationForm(loaningState.DRAFT)" color="primary"
              [disabled]="! canSendDraft()" data-cy="btn-consult-edit-save">
        Sauvegarder en tant que brouillon
      </button>
    </span>
    <span [matTooltip]="toolTipSendButton()"
          [matTooltipClass]="'tooltip'"
          [matTooltipDisabled]="canSendLoaning()">
      <button mat-raised-button type="button" (click)="sendLoaning()" color="accent"
              [disabled]="! canSendLoaning()" data-cy="btn-consult-edit-send">
        Envoyer ma demande de consultation
      </button>
    </span>
  </p8-layout-settings-footer>
</p8-layout-settings-page>
